module.exports = __webpack_public_path__ + "static/media/facilidade.dd1dd147.svg";